import { render, staticRenderFns } from "./ChangeMainContact.vue?vue&type=template&id=7391aca5&"
import script from "./ChangeMainContact.vue?vue&type=script&lang=js&"
export * from "./ChangeMainContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports